/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import avatar from '../assets/img/Avatar.webp'

import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarNav,
    MDBNavbarItem,
} from 'mdb-react-ui-kit';

import "../style/css/header.css"

interface HeaderProps {
  userName: string;
}

const Header: React.FC<HeaderProps> = ({ userName,  }) =>{

  const handleLogout = () => {
      localStorage.removeItem("sessionToken");
      localStorage.removeItem("sessionTokenExpiration");
      localStorage.removeItem("specialTokenDev");
      localStorage.removeItem("specialTokenAdmin");
      localStorage.removeItem("specialTokenSuperAdmin");
      localStorage.removeItem("NameUser");
     
      window.location.href="/"
    };

  return(
    
    <MDBNavbar sticky id='main-navbar'>

      <MDBContainer id='headercontainer'>
        
        <MDBNavbarNav right fullWidth={false} className='' id="listnavbar">

            <MDBNavbarItem>

             <button className="message" onClick= {handleLogout}> Se déconnecter </button> 

            </MDBNavbarItem>

            <MDBNavbarItem>
              <p className="textItem"> Bonjour {userName}</p>
            </MDBNavbarItem>

            <MDBNavbarItem>
              <img
              src={avatar}
              className='rounded-circle'
              height='22'
              alt=''
              loading='lazy'/>
            </MDBNavbarItem>

        </MDBNavbarNav>

       </MDBContainer>
    </MDBNavbar>

  )
}

export default Header